<template>
  <div class="form-block">
    <div class="container-fluid">
      <div class="row">
        <h2>Zaznacz rodzaje stosowanego paliwa</h2>
      </div>

      <div class="row" v-for="(fuelType, index) in selectedFuelTypes" :key="fuelType.id">
        <div class="col-12">
          <label>
            <input
              type="checkbox"
              v-model="fuelType.selected"
            >
            {{ fuelType.name }}
          </label>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import InputDropdown from "@/components/common/InputDropdown";
import ZoneIcon from "@/components/common/ZoneIcon";
import DeclarationModel from "@/models/declarations";
import Common from "@/components/declarations/validators/Common";


export default {
  name: "FuelTypesScreen",
  mixins: [Common],
  components: {InputDropdown, ZoneIcon},
  data() {
    return {
      fuelTypes: [],
      selectedFuelTypes: []
    }
  },
  methods: {
    setData(data) {
      const self = this;
      data.used_fuels.forEach((fuel) => {
        const fuelIndex  = self.selectedFuelTypes.findIndex((selectedFuelType) => fuel.id === selectedFuelType.id);
        if ( self.selectedFuelTypes.length && self.selectedFuelTypes[fuelIndex]) {
          self.selectedFuelTypes[fuelIndex].selected = true;
        }
      });
    },
    emitChange() {
      let data = {
        usedFuels: this.selectedFuelTypes
          .filter((el) => el.selected)
          .map((el) => el.abbreviation)
      }
      this.$emit('update', data);
    },
    getFuelClasses() {
      DeclarationModel.getFuelClasses()
        .then((res) => {
          this.selectedFuelTypes = res.data.map((el) => {
            el.selected = false;
            return el;
          });
        });
    }
  },
  mounted() {
    this.getFuelClasses();
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

input[type=text] {
  height: 2rem;
}

hr {
  border: 0;
  border-top: 2px solid #dadada;
  margin: 1rem -2.45rem;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
  color: #6f6f6f;
}

a, a label {
  color: #000000;
  cursor: pointer;
}

a label {
  padding: 0 1rem;
  font-family: "Volte Semibold", serif;
  color: #6e7182;
  cursor: pointer;
}

.row {
  width: 100%;
}
</style>
